<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line clickable" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
        <i class="material-icons">portable_wifi_off</i>
      </div>
      <div class="ir-btn th-btn-icon" *ngIf="inspection?.isOffline">
        <i class="material-icons warning" *ngIf="inspection?.updatedOffline">offline_pin</i>
        <i class="material-icons offline" *ngIf="!inspection?.updatedOffline">offline_pin</i>
      </div>
      <div class="ir-btn th-btn-icon" *ngIf="!inspection?.isOffline && inspection?.isSynchronizing">
        <i class="material-icons offline">sync</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content" (click)="gotoEditPage()">
      <span
        >{{ title }} <strong>{{ completedPointsCount }} / {{ itemsCount }}</strong></span
      >
    </div>
    <div class="ir-popup th-popup">
      <span
        ><strong>{{ inspection.name }}</strong></span
      >
      <span *ngIf="folder"
        >/ <strong>{{ folder.section.name }}</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)"><i class="material-icons">close</i>4</div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right" [permissions]="[['visible', 'inspection.offline.edit', inspection]]">
        <button class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right" (click)="createPoint()">
          <span>{{ 'sections.add-new-point' | translate }}</span>
        </button>
      </div>
      <div class="ir-line--right">
        <ng-container *ngFor="let session of folderId ? folder?.sessionIcons : section?.sessionIcons">
          <i
            *ngIf="session.user"
            (click)="navigateToSession(session)"
            [title]="session.user"
            class="material-icons session"
            [style.color]="session.color"
            [class.disabled]="session.away"
            [class.away]="session.away"
            [class.active]="!session.away"
            [class.highlight]="session.highlight && !session.away"
            >account_circle</i
          >
        </ng-container>
      </div>
      <div class="ir-line-content">
        <span>{{ folderId ? ('folders.sub-checkpoints' | translate) : ('sections.checkpoints' | translate) }}</span>
      </div>
    </div>
    <point-list-table
      [inspection]="inspection"
      [updateSubject]="updateSubject"
      [points]="points"
      [folders]="folders"
      (toggleOpenPoint)="openPoint($event)"
      (toggleOpenFolder)="openFolder($event)"
      (toggleSelectPoint)="selectPoint($event)"
      (toggleSelectFolder)="selectFolder($event)"
      [query]="query"
    ></point-list-table>
  </div>
</div>
<modal (modalOutput)="selectMenu($event)"></modal>
<ng-container *ngFor="let point of points">
  {{ point.name }}
</ng-container>

<order-summaries
  #orderPoints
  [title]="'sections.order-items' | translate"
  (toggleSave)="saveItemsOrder($event)"
  (toggleCancel)="cancel()"
></order-summaries>
<confirm
  *ngIf="!folderId"
  #deleteConfirm
  (confirmOutput)="deleteSection($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  *ngIf="folderId"
  #deleteConfirm
  (confirmOutput)="deleteFolder($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete-folder' | translate"
  [danger]="true"
></confirm>
<confirm
  #deleteFoldersConfirm
  (confirmOutput)="deleteFolders($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete-folders' | translate"
  [danger]="true"
></confirm>
<confirm
  #pointsDeleteConfirm
  (confirmOutput)="deletePoints($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete-points' | translate"
  [danger]="true"
></confirm>
<confirm
  #selectedDeleteConfirm
  (confirmOutput)="deleteSelectedItems($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'common.sure-to-delete-items' | translate"
  [danger]="true"
></confirm>
<confirm
  #pastingFolderToFolderConfirm
  (confirmOutput)="paste()"
  [title]="'common.paste-confirmation' | translate"
  [message]="'sections.sure-to-folder-omitting' | translate"
  [danger]="true"
></confirm>
<confirm-with-options
  #clipboardPasteReplaceConfirm
  (confirmOutput)="replaceOnPast($event)"
  [okButtonsSettings]="[
    { text: 'common.replace' | translate, value: true, buttonClass: 'th-btn-remove' },
    { text: 'common.ok' | translate, value: false, buttonClass: 'th-btn-modal--action' }
  ]"
  [title]="'common.paste-confirmation' | translate"
  [message]="'common.sure-to-replace-items' | translate"
></confirm-with-options>
